import CustomizableGeneric from './CustomizableGeneric';

class SearchAction extends CustomizableGeneric {
  getTypeName = () => 'SearchAction';

  getFields = () => ['target', 'query-input'];
}

export default SearchAction;
